export const LANGUAGES = [
  { code: "en", label: "English (US)", short: "EN", locale: "en-US", primary: true },
  { code: "es-ES", label: "Español (España)", short: "ES", locale: "es-ES" },
  { code: "es-MX", label: "Español (México)", short: "MX", locale: "es-MX" },
  { code: "it", label: "Italiano", short: "IT", locale: "it-IT" },
  { code: "de", label: "Deutsch", short: "DE", locale: "de-DE" },
  { code: "pl", label: "Polski", short: "PL", locale: "pl-PL" },
  { code: "pt-BR", label: "Português (Brasil)", short: "BR", locale: "pt-BR" },
  { code: "pt-PT", label: "Português (Portugal)", short: "PT", locale: "pt-PT" },
  { code: "ru", label: "Русский", short: "RU", locale: "ru-RU" },
  { code: "uk", label: "Українська", short: "UA", locale: "uk-UA" },
  { code: "fr", label: "Français", short: "FR", locale: "fr-FR" },
];

export const LANGUAGE_CODES = LANGUAGES.map((language) => language.code);

export function findLanguage(code) {
  if (!code) return LANGUAGES[0];

  const normalized = code.toLowerCase();
  const exact = LANGUAGES.find((language) => language.code.toLowerCase() === normalized);
  if (exact) return exact;

  const base = normalized.split("-")[0];
  const baseMatch = LANGUAGES.find((language) => language.code.toLowerCase() === base);
  if (baseMatch) return baseMatch;

  if (base === "es") {
    return LANGUAGES.find((language) => language.code === "es-ES") || LANGUAGES[0];
  }
  if (base === "pt") {
    return LANGUAGES.find((language) => language.code === "pt-BR") || LANGUAGES[0];
  }

  return LANGUAGES.find((language) => normalized.startsWith(language.code.toLowerCase())) || LANGUAGES[0];
}

export function resolveContentLanguage(language, availableKeys = ["en", "ru"]) {
  if (!language) return "en";

  const normalized = language.toLowerCase();
  const direct = availableKeys.find((key) => key.toLowerCase() === normalized);
  if (direct) return direct;

  const base = normalized.split("-")[0];
  const baseMatch = availableKeys.find((key) => key.toLowerCase() === base);
  if (baseMatch) return baseMatch;

  if (normalized.startsWith("ru") && availableKeys.includes("ru")) return "ru";
  if (availableKeys.includes("en")) return "en";
  return availableKeys[0] || "en";
}

export function getDateLocale(language) {
  return findLanguage(language).locale;
}
